import React from 'react'
import { Box, Button, CircularProgress } from '@material-ui/core'
import { SaveIcon } from '~/assets/icons'

export type ConfirmDocumentsFooterProps = {
  loading: boolean,
  onClick: () => void,
  onCancelClick: () => void
}

export const ConfirmDocumentsFooter: React.FC<ConfirmDocumentsFooterProps> = (props) => {
  const { onClick, onCancelClick, loading } = props

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: {
          xs: 'column',
          md: 'row'
        }
      }}
    >
      <Button
        type='submit'
        size='large'
        color='info'
        onClick={onCancelClick}
        disabled={loading}
        variant='contained'
        sx={{
          height: 56,
          marginTop: 2,
          fontWeight: 700,
          alignSelf: 'center',
          textTransform: 'none',
          color: 'secondary.main',
          backgroundColor: 'badgeBorderColor.info.main'
        }}
      >
        Continuar sem salvar
      </Button>
      <Button
        type='submit'
        size='large'
        color='primary'
        onClick={onClick}
        disabled={loading}
        variant='contained'
        sx={{
          height: 56,
          marginTop: 2,
          fontWeight: 700,
          alignSelf: 'center',
          textTransform: 'none'
        }}
        startIcon={loading ? <CircularProgress color='inherit' size={20} /> : <SaveIcon width={24} height={24} />}
      >
        Salvar e continuar
      </Button>
    </Box>
  )
}
